import classNames from 'classnames'
import { WizardStepProperties } from 'components/types'
import { ChangeEvent, useEffect } from 'react'

const BooleanInput = ({
  name,
  label,
  parentStep,
  value,
  onChange,
  setIsValid,
}: WizardStepProperties) => {
  const handleToggle = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target

    if (parentStep) {
      return onChange({
        name: parentStep,
        type: 'parentCheckbox',
        value: { name: name, value: checked },
      })
    }
    return onChange({
      name: name,
      type: 'checkbox',
      value: checked,
    })
  }

  useEffect(() => {
    setIsValid?.(true)
  }, [setIsValid])

  return (
    <div className="flex items-center mb-4">
      <label className="flex-grow text-lg sm:text-base font-semibold">
        {label}
      </label>
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          name={name}
          type="checkbox"
          value={value as string}
          onChange={handleToggle}
          className="sr-only"
        />
        <div
          className={classNames(
            'rounded-full shadow-inner',
            value ? 'bg-imovPrimary' : 'bg-gray-300',
            'w-14 h-8',
            'sm:w-10 sm:h-6'
          )}
        ></div>
        <div
          className={`absolute left-1 top-1 rounded-full shadow transition-transform duration-200 bg-white
          w-6 h-6 sm:w-4 sm:h-4 ${value ? 'transform translate-x-6 bg-blue-500' : ''}
        `}
        ></div>
      </label>
    </div>
  )
}

export default BooleanInput
